import { chartsCustomizations } from './charts';
import { dataGridCustomizations } from './dataGrid';
import { datePickersCustomizations } from './datePickers';
import { treeViewCustomizations } from './treeView';

// Optional exports (agar kahin aur use ho toh)
export {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
};

// 👇 Fix for TextField border + placeholder alignment
export const inputFieldCustomizations = {
    
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#757575',
          '&.Mui-focused': {
            color: '#1976d2', // optional: label color on focus
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '12px 14px',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          padding: '0 !important',
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px !important',
          },
        },
      },
    },
  };
  

// 👇 Final merged export
export const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
//   ...inputFieldCustomizations,
};
